"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Loader_1 = require("./../../Loader");
var s = require("./Dropdown.scss");
var Dropdown = (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.currentOptionIndex = -1;
        _this.setDropdownRef = function (ref) { return _this.node = ref; };
        _this.hideDropdownMenu = function () {
            _this.setState({
                isOptionsListOpened: false,
            });
        };
        _this.handleClickOutside = function (event) {
            /* istanbul ignore next */
            if (_this.node && !_this.node.contains(event.target)) {
                _this.hideDropdownMenu();
            }
        };
        _this.showDropdownMenu = function () { return !_this.props.disabled && _this.setState({ isOptionsListOpened: true }); };
        _this.handleKeyDown = function (e) {
            e.stopPropagation();
            var options = _this.props.options;
            switch (e.key) {
                case 'ArrowUp': {
                    e.preventDefault();
                    if (_this.currentOptionIndex <= 0) {
                        _this.currentOptionIndex = options.length;
                    }
                    _this.currentOptionIndex--;
                    if (options[_this.currentOptionIndex]) {
                        _this.setState({ selectedOptionId: options[_this.currentOptionIndex].value });
                        var node = document.getElementById("dropdown-option-" + options[_this.currentOptionIndex].id);
                        /* istanbul ignore next */
                        if (node.offsetTop - _this.dropdownMenuNode.scrollTop <= 0) {
                            _this.dropdownMenuNode.scrollTop = node.offsetTop;
                        }
                        /* istanbul ignore next */
                        if (_this.dropdownMenuNode.scrollTop <= 0) {
                            _this.dropdownMenuNode.scrollTop = node.offsetTop;
                        }
                    }
                    break;
                }
                case 'ArrowDown': {
                    e.preventDefault();
                    if (!_this.state.isOptionsListOpened) {
                        _this.showDropdownMenu();
                    }
                    if (_this.currentOptionIndex >= options.length - 1) {
                        _this.currentOptionIndex = -1;
                    }
                    _this.currentOptionIndex++;
                    if (options[_this.currentOptionIndex]) {
                        _this.setState({ selectedOptionId: options[_this.currentOptionIndex].value });
                        var node = document.getElementById("dropdown-option-" + options[_this.currentOptionIndex].id);
                        if (_this.dropdownMenuNode.offsetHeight <= node.offsetTop) {
                            _this.dropdownMenuNode.scrollTop = node.offsetTop;
                        }
                        if (_this.dropdownMenuNode.scrollTop >= node.offsetTop) {
                            _this.dropdownMenuNode.scrollTop = 0;
                        }
                    }
                    break;
                }
                case 'ArrowRight':
                case 'Enter':
                case 'Tab': {
                    if (options[_this.currentOptionIndex]) {
                        _this.onOptionClick(options[_this.currentOptionIndex])();
                    }
                    break;
                }
                default: {
                    break;
                }
            }
        };
        _this.handleTextChange = function (e) {
            if (!_this.state.isOptionsListOpened) {
                _this.showDropdownMenu();
            }
            if (_this.props.onChange) {
                _this.props.onChange(e);
            }
        };
        _this.loadSymbolPolyfillIfRequired();
        return _this;
    }
    Dropdown.prototype.loadSymbolPolyfillIfRequired = function () {
        var symbolLoader = document.createElement('script');
        symbolLoader.src = 'https://static.parastorage.com/polyfill/v2/polyfill.js?features=Symbol';
        symbolLoader.async = true;
        document.head.appendChild(symbolLoader);
    };
    Dropdown.prototype.componentWillMount = function () {
        this.setState({
            isOptionsListOpened: false,
            selectedOptionId: this.props.defaultOptionId,
        });
    };
    Dropdown.prototype.onOptionSelection = function (option) {
        this.setState({
            isOptionsListOpened: false,
            selectedOptionId: option.id,
        });
        this.props.onSelect(option);
    };
    Dropdown.prototype.onOptionClick = function (option) {
        var _this = this;
        return (function () { return _this.onOptionSelection(option); });
    };
    Dropdown.prototype.componentDidMount = function () {
        document.addEventListener('click', this.handleClickOutside);
    };
    Dropdown.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleClickOutside);
    };
    Dropdown.prototype.renderDropdownInput = function () {
        var _this = this;
        var selectedOption = this.props.options.find(function (option) { return option.id === _this.state.selectedOptionId; });
        if (this.props.autocomplete) {
            return (React.createElement("div", { onClick: this.showDropdownMenu, "data-hook": "cashier-payments-method-dropdown" },
                React.createElement("input", { onKeyDown: this.handleKeyDown, disabled: this.props.disabled, className: s.input, value: this.props.autocompleteInputValue, onChange: this.handleTextChange, onFocus: this.props.onFocus, onBlur: this.props.onBlur }),
                React.createElement("div", { className: s.dropdownArrow })));
        }
        return (React.createElement("div", { className: classNames(s.option, (_a = {}, _a[s.selectedOptionNonActiveState] = !this.state.isOptionsListOpened, _a)), onClick: this.showDropdownMenu, "data-hook": "cashier-payments-method-dropdown" },
            React.createElement("span", { className: s.optionLabel }, selectedOption ? selectedOption.label : null),
            React.createElement("div", { className: s.dropdownArrow })));
        var _a;
    };
    Dropdown.prototype.renderDropdownMenu = function () {
        var _this = this;
        if (!this.state.isOptionsListOpened) {
            return null;
        }
        return (React.createElement("div", { "data-hook": "cashier-payments-method-dropdown-menu", className: s.dropdownOptions, ref: function (node) { return _this.dropdownMenuNode = node; } },
            this.props.isLoadingOptions
                ? React.createElement("div", { "data-hook": "cashier-payments-method-dropdown-spinner", className: s.loader },
                    React.createElement(Loader_1.default, { size: "small" }))
                : null,
            this.props.options.map(function (option) {
                return (React.createElement("div", { "data-hook": "cashier-payments-method-dropdown-option-" + option.id, key: option.id, id: "dropdown-option-" + option.id, className: classNames(s.option, s.selectableOption, (_a = {}, _a[s.currentSelection] = option.id === _this.state.selectedOptionId, _a)), onClick: _this.onOptionClick(option) },
                    React.createElement("span", { className: s.optionLabel }, option.label)));
                var _a;
            })));
    };
    Dropdown.prototype.render = function () {
        return (React.createElement("div", { ref: this.setDropdownRef, className: s.dropdownContainer },
            this.renderDropdownInput(),
            this.renderDropdownMenu()));
    };
    return Dropdown;
}(React.Component));
exports.default = Dropdown;
//# sourceMappingURL=Dropdown.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Fields/Dropdown/Dropdown.js
// module id = 68
// module chunks = 0 1